export default __webpack_public_path__ + "static/media/0b491870582f8a7ad9bf.0b491870.svg";